<template>
  <div class="container">
    <header>
      <h2>{{ $t('devicePosition.title') }}</h2>
      <a-input v-show="isMapShow" v-model="deviceCode" :placeholder="$t('messages.pedc')" style="width: 70%;" @keyup.enter="searchRecords" />
      <a-space>
        <a-button v-show="isButtonShow" type="primary" @click="hanldeSearch">{{ $t('buttons.search') }}</a-button>
        <a-button v-show="isMapShow" @click="afterCloseMap">{{ $t('buttons.goBack') }}</a-button>
      </a-space>
    </header>
    <div id="map" v-show="isMapShow"></div>
    <div class="mask" :style="{ zIndex: loading ? 1 : -1 }" v-loading="loading" />
    <div v-show="!isMapShow">
      <el-table style="width: 99%; margin: 0 auto" :header-cell-style="{ backgroundColor: '#fafafa' }" v-loading="isTableLoading" :data="deviceRecords">
        <el-table-column label="整机编号" prop="deviceCode">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left">
              {{ $t('device.code') }}
            </div>
            <a-input
              @keyup.enter="queryRecords"
              allow-clear
              v-model.trim="queryParams.deviceCode"
            />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highLightInfo.deviceCode">{{ scope.row.deviceCode }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column label="机型" prop="model">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left">
              {{ $t('common.model') }}
            </div>
            <a-input
              @keyup.enter="queryRecords"
              allow-clear
              v-model.trim="queryParams.model"
            />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highLightInfo.model">{{ scope.row.model }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column label="客户名称" prop="company" width="300">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left">
              {{ $t('common.customer') }}
            </div>
            <a-input
              @keyup.enter="queryRecords"
              allow-clear
              v-model.trim="queryParams.company"
            />
          </template>
          <template slot-scope="scope">
            <text-highlight :queries="highLightInfo.company">{{ scope.row.company }}</text-highlight>
          </template>
        </el-table-column>
        <el-table-column label="定位更新时间" prop="positionUpdatedAt">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left">
              {{ $t('devicePosition.positionUpdatedAt') }}
              <span
                @click="handleSort($event, 'positionUpdatedAt')"
                class="icons DESC"
                style="cursor: pointer"
                data-index="0"
              >
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="createdAt">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left">
              {{ $t('common.createdAt') }}
              <span
                @click="handleSort($event, 'createdAt')"
                class="icons unset"
                style="cursor: pointer"
                data-index="0"
              >
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="经度" prop="lng">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left">
              {{ $t('devicePosition.longitude') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="纬度" prop="lat">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left">
              {{ $t('devicePosition.latitude') }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="纬度" prop="lat">
          <template #header>
            <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left">
              {{ $t('common.operation') }}
            </div>
          </template>
          <template slot-scope="scope">
            <a-button type="link" style="padding: 0;" @click="showMap(scope.row.deviceCode)">{{ $t('devicePosition.showMap') }}</a-button>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <a-pagination :hideOnSinglePage="true" :current="pagination.current" :pageSize="pagination.pageSize" :total="pagination.total" style="float: right; margin: 10px" @change="hanldePageChange" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ping from '@/assets/poi-marker-red.png'
import TextHighlight from "vue-text-highlight"
import { nanoid } from 'nanoid'
import { 
  getDevicePositionHistory,
  queryDevicePositionHistory
} from '@/api/device'
import { searchCustomerList } from "@/api/customer"

export default {
  components: {
    TextHighlight
  },
  data() {
    return {
      deviceCode: '',
      loading: false,
      isMapShow: false,
      isButtonShow: false,
      queryParams: {
        deviceCode: '',
        model: '',
        company: ''
      },
      highLightInfo: {
        deviceCode: '',
        model: '',
        company: ''
      },
      isButtonShow: false,
      isTableLoading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      sort: [
        {
          field: 'positionUpdatedAt',
          value: 'DESC'
        }
      ],
      deviceRecords: []
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang() {
      this.searchRecords()
    }
  },
  created() {
    this.ids = []
    const authorities = this.getAuthorities(this.$route.path)
    if (authorities) {
      this.isButtonShow = authorities.find(a => a.code === 'device:position:history:query')
    }
  },
  activated() {
    if (this.$route.query.deviceCode) {
      this.showMap(this.$route.query.deviceCode)
    } else {
      this.queryRecords()
    }
  },
  async mounted() {
    try {
      await this.loadScript("https://webapi.amap.com/maps?v=2.0&key=72d96f391e31901608daed111c3535e4")
      await this.loadScript("//webapi.amap.com/ui/1.1/main.js")
      this.scriptLoadedSuccess = true
      this.initMapChart()
    } catch(e) {
      console.log(e)
      this.scriptLoadedSuccess = false
    }
  },
  methods: {
    async loadScript(src) {
      return new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${src}"]`)
        if (existingScript) {
          resolve()
          return
        }
        const script = document.createElement("script")
        script.type = "text/javascript"
        script.src = src
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
    },
    async searchRecords() {
      this.loading = true
      this.deviceCode = this.deviceCode.trim()
      let container
      for (let i = 0; i < this.ids.length; i++) {
        container = document.getElementById(this.ids[i])
        container?.remove()
        this.markers[i].setMap(null)
      }
      this.ids = []
      this.markers = []
      this.path = []
      try {
        if (this.deviceCode) {
          const deviceCode = this.deviceCode.split('-').join('')
          const { data } = await getDevicePositionHistory({
            deviceCode
          })
          if (!data.length) {
            this.$message.info(this.$t('devicePosition.noHistory'))
          }
          this.records = data
          const promises = []
          this.path = data.map((d, i) => {
            this.ids.push('id' + nanoid())
            promises.push(new Promise(async resolve => {
              try {
                const { data } = await searchCustomerList(1, 10, {
                  query: [],
                  filter: [
                    {
                      field: 'company',
                      value: this.records[i].company
                    }
                  ],
                  sort: [
                    {
                      field: 'updatedAt',
                      value: 'DESC'
                    }
                  ]
                })
                if (data.total) {
                  this.records[i].address = data.records[0].address
                }
                resolve()
              } catch(e) {
                console.log(e)
                resolve()
              }
            }))
            return [d.lng, d.lat]
          })
          await Promise.all(promises)
          this.drawPolyline()
          this.drawMarkers()
          this.$nextTick(() => {
            for (let i = 0; i < this.ids.length; i++) {
              const container = document.getElementById(this.ids[i])
              container.addEventListener('mousedown', e => e.stopPropagation())
              const img = container.querySelector('img')
              const description = container.querySelector('.description')
              img.addEventListener('click', () => {
                description.style.opacity = description.style.opacity == 1 ? 0 : 1
              })
            }
          })
        }
      } catch(e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    async drawMap() {
      this.map = new AMap.Map("map", {
        resizeEnable: true,
        center: [121.313024, 30.155917],
        zoom: 17,
        bubble: false
      })

      this.map.setFitView()
    },
    async queryRecords() {
      this.isTableLoading = true
      const query = []
      for (let k in this.queryParams) {
        query.push({
          field: k,
          value: this.queryParams[k]
        })
      }
      const sort = this.sort || []

      try {
        const { data } = await queryDevicePositionHistory(this.pagination.current, this.pagination.pageSize, {
          query,
          filter: [],
          sort
        })
        this.deviceRecords = data.records.map(r => {
          r.positionUpdatedAt = moment(+r.positionUpdatedAt).format('YYYY-MM-DD HH:mm:ss')
          r.createdAt = moment(+r.createdAt).format('YYYY-MM-DD HH:mm:ss')
          return r
        })
        this.pagination.total = data.total

        for (let k in this.queryParams) {
          this.highLightInfo[k] = this.queryParams[k]
        }
      } catch(e) {
        console.log(e)
      } finally {
        this.isTableLoading = false
      }
    },
    drawPolyline() {
      if (this.polyline) {
        this.polyline.setMap(null)
        this.polyline = null
      }
      if (this.path.length) {
        this.polyline = new AMap.Polyline({
          map: this.map,
          path: this.path,
          showDir: true,
          strokeColor: "#28F",
          strokeWeight: 6
        })
        this.map.setFitView()
      }
    },
    drawMarkers() {
      let id, record
      for (let i = 0; i < this.ids.length; i++) {
        id = this.ids[i]
        record = this.records[i]
        this.markers.push(new AMap.Marker({
          map: this.map,
          position: this.path[i],
          content: `
            <div class="info_container" id="${id}">
              <img src="${ping}" style="width: 25px; height: 34px;" />
              <div class="description" style="opacity: 0; transition: opacity .8s">
                <p>${ this.$t('devicePosition.arriveTime') }: ${ moment(record.positionUpdatedAt).format('YYYY-MM-DD HH:mm:ss') }</p>
                <p>${ this.$t('customer.company') }: ${ record.company }</p>
                <p>${ this.$t('customer.address') }: ${ record.address }</p>
              </div>
            </div>
          `,
          offset: new AMap.Pixel(-13, -30)
        }))
      }
    },
    handleSort(e, field) {
      let i = e.target
      let c = ""
      while (i.nodeName !== "SPAN") {
        i = i.parentNode
      }
      switch (i.classList[1]) {
        case "ASC":
          c = "DESC"
          break
        case "DESC":
          c = "unset"
          break
        case "unset":
          c = "ASC"
          break
        default:
          break
      }
      i.classList.remove(i.classList[1])
      i.classList.add(c)
      const f = this.sort.findIndex(s => s.field === field)
      if (f < 0) {
        if (c !== "unset") {
          this.sort.push({
            field,
            value: c
          })
        }
      } else {
        if (c === "unset") {
          this.sort.splice(f, 1)
        } else {
          this.sort[f].value = c
        }
      }
      this.queryRecords()
    },
    hanldePageChange(p) {
      this.pagination.current = p
      this.queryRecords()
    },
    hanldeSearch() {
      if (this.isMapShow) {
        this.searchRecords()
      } else {
        this.queryRecords()
      }
    },
    showMap(code) {
      this.isMapShow = true
      this.deviceCode = code
      this.drawMap()
      this.searchRecords()
    },
    afterCloseMap() {
      if (this.$route.query.from === 'list') {
        this.$router.back()
      } else {
        this.isMapShow = false
        this.path = []
        this.ids = []
      }
    }
  }
}
</script>

<style lang="less" scoped>
h2 {
  margin: 0;
  padding: 0;
}
.container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    padding: 0 10px;
    margin: 10px 0;
  }
  #map {
    flex: 1;
    width: 100%;
  }
  .btn_group {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
}
/deep/ .info_container {
  display: flex;
  position: relative;
  .description {
    position: absolute;
    top: 50%;
    left: 30px;
    transform: translateY(-50%);
    background-color: rgba(255, 255, 255, .8);
    padding: 10px;
    p {
      white-space: nowrap;
      margin: 0;
      padding: 0;
      &:nth-child(2) {
        margin: 10px 0;
      }
    }
  }
}
.mask {
  position: absolute;
  top: 50px;
  left: 0;
  right: 0;
  bottom: 0;
  // background-color: rgba(0, 0, 0, .1);
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .el-table {
  .anticon-caret-up {
    position: absolute;
    top: -1px;
    right: -8px;
    font-size: 14px;
    color: #ccc;
  }
  span.ASC .anticon-caret-up {
    color: #1890ff;
  }
  span.icons {
    position: absolute;
    right: 18px;
  }
  span.DESC .anticon-caret-down {
    color: #1890ff;
  }
  .anticon-caret-down {
    position: absolute;
    top: 8px;
    right: -8px;
    font-size: 14px;
    color: #ccc;
  }
}
</style>